import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductKitHeaderComponent } from './product-kit-header/product-kit-header.component';
import {PipesModule} from '../../providers/pipes/pipes.module';
import { ProductKitGalleryComponent } from './product-kit-gallery/product-kit-gallery.component';
import {SwiperModule} from 'ngx-swiper-wrapper';
import {TranslateModule} from "@ngx-translate/core";



@NgModule({
  declarations: [ProductKitHeaderComponent, ProductKitGalleryComponent],
    imports: [
        CommonModule,
        PipesModule,
        SwiperModule,
        TranslateModule
    ],
  exports: [ProductKitHeaderComponent, ProductKitGalleryComponent]
})
export class ProductKitModule { }
